import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { partitionsStatusSelector } from '../selectors/dashboardSelector';
import { getPartitionsStatusRequest } from '../actions/dashboardActions';
import PartitionsStatus from '../components/PartitionsStatus/PartitionsStatus';

const mapStateToProps = createStructuredSelector({ partitionsStatus: partitionsStatusSelector });
const mapDispatchToProps = { getPartitionsStatusRequest };

export default connect(mapStateToProps, mapDispatchToProps)(PartitionsStatus);
